import { render } from "./EmpresaForm.vue?vue&type=template&id=3772320a&scoped=true"
import script from "./EmpresaForm.vue?vue&type=script&lang=js"
export * from "./EmpresaForm.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=3772320a&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3772320a"]])

export default __exports__